import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-campus-program-data-science',
  templateUrl: './campus-program-data-science.component.html',
  styleUrls: ['./campus-program-data-science.component.scss']
})
export class CampusProgramDataScienceComponent implements OnInit {
  course_details = environment.course_date_advanced_data_science_and_AI;
  certificateImage = 'assets/img/live-courses/certificate/Advanced-Data-Science.png';
  course_date_month = environment.course_date_month;
  course_class_mode_text = [
    '🔴 Live Interactive Sessions',
    '🎥 Access to Class Recordings',
    '❓Dedicated Doubt Support',
    '🏆 Course Certification',
    '🛠 Hands-on Project Work',
    '🎁 Final Project and Exciting Goodies'
  ]
  currentTextIndex: number = 0;
  classFeature: string = this.course_class_mode_text[this.currentTextIndex];
  mentor = {
    name: 'Manan Gupta',
    title2: '',
    title: 'Associate Software Developer at JPMorgan Chase & Co.',
    image: 'assets/img/live-courses/manan.jpeg', // Update with actual image path
    linkedinUrl: 'https://www.linkedin.com/in/manan-gupta-167a9914a/'
  };

  stats = [
    { value: '2,000+', label: 'Students Mentored' },
    { value: 'JPMorgan Chase & Co.', label: 'Associate Software Developer' },
  ];
  constructor(
    private modalService: ModalService) { }

  ngOnInit(): void {
    setInterval(() => {
      this.currentTextIndex = (this.currentTextIndex + 1) % this.course_class_mode_text.length;
      this.classFeature = this.course_class_mode_text[this.currentTextIndex];
    }, 3000);
  }


  moduleArray = [
    {
      id: 1,
      active: false,
      courseTopic: 'Fundamentals of Data Science & Machine Learning',
      timeTaking: '1st week',
      isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            'Introduction to Data Science, AI, and ML',
            'Supervised vs Unsupervised Learning',
            'Essential ML Algorithms: Regression, Classification, Clustering',
            'Model Evaluation (Accuracy, Precision, Recall, F1-score)',

          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Build a classification model using real-world datasets (e.g., fraud detection, medical diagnosis, or stock price prediction).'
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 2,
      active: false,
      courseTopic: 'Deep Learning & Neural Networks',
      timeTaking: '2rd week',
        isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Dive into the core principles of Machine Learning with our module, exploring fundamental algorithms and techniques to empower your understanding and application of this transformative field.',
          moduleContant: [
            'Introduction to Neural Networks (ANNs, CNNs, RNNs)',
            'Backpropagation & Optimization Techniques (SGD, Adam)',
            'Convolutional Neural Networks (Image Processing & Computer Vision)',
            'Recurrent Neural Networks (Time Series, Sequential Data)',
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Train a CNN for image classification (e.g., handwritten digit recognition using MNIST or dog vs. cat classification).'
              ]
            }

          ],

          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 3,
      active: false,
      courseTopic: 'Generative AI & Image Generation',
      timeTaking: '3rd week',
        isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Navigate the realm of Statistical Thinking and Descriptive Analysis, gaining insights into data through analytical techniques and methodologies in our comprehensive course module.',
          moduleContant: [
            'Introduction to Generative Models (Autoencoders, GANs, VAEs)',
            'GANs: Architecture, Training, and Applications',
            'Diffusion Models & Stable Diffusion',
            'Ethical Considerations in Generative AI',
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ' Train a GAN to generate synthetic images (e.g., generate human faces, fashion designs, or artistic images)'
              ]
            }

          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 4,
      active: false,
      courseTopic: 'Advanced Generative AI & Text Generation',
      timeTaking: '4th week',
        isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Dive into the core principles of Machine Learning with our module, exploring fundamental algorithms and techniques to empower your understanding and application of this transformative field.',
          moduleContant: [
            'Transformer Models (BERT, GPT) and Self-Attention Mechanism',
            'Introduction to Large Language Models (LLMs)',
            'Fine-tuning vs Prompt Engineering',
            'AI-generated Text Applications (Text Summarization, Content Generation)',
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Fine-tune GPT or BERT on a custom dataset (e.g., news summarization, legal document analysis, or poetry generation).'
              ]
            }

          ],

          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 5,
      active: false,
      courseTopic: 'Multimodal AI & Cross-Domain Generative AI',
      timeTaking: '5th week',
        isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: `Explore the forefront of data science with the Advanced Data Science Techniques module, encompassing advanced methods, NLP, and Deep Learning strategies to tackle complex challenges and extract profound insights from diverse datasets.`,
          moduleContant: [
            'Combining Text, Image, and Video in AI Models',
            'Text-to-Image & Image-to-Text Models (DALL·E, CLIP)',
            'AI for Music and Video Generation',
            'Real-World Applications of Multimodal AI',
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Create a text-to-image generation model using CLIP or Stable Diffusion (e.g., generate artwork based on text prompts).'
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        },

      ]
    },
    {
      id: 6,
      active: false,
      courseTopic: 'AI Ethics, Explainability, and Final Project',
      timeTaking: '6th weeks',
      isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: `Embark on an exploration of Language Models and the Language Frontier in our fourth module, delving into the cutting-edge realms of NLP and Deep Learning to master language processing techniques and advance your data science skills.`,
          moduleContant: [
            'AI Bias & Fairness in Generative AI',
            'Explainability in AI (XAI) & Model Interpretability',
            'Future of Generative AI & Industry Applications',
          ],
          project: [],
          outComes: 'Develop a Generative AI-powered application (e.g., AI-generated storytelling, AI-powered design tool, or personalized content generator).'
        },

      ]
    },

  ]

  toggleCourseTitle(selectedData, index) {
    for (let i = 0; i < this.moduleArray.length; i++) {
      if (this.moduleArray[i].id == selectedData.id) {
        this.moduleArray[i].active = !this.moduleArray[i].active;
      } else {
        this.moduleArray[i].active = false;
      }
    }
  }

  downloadBroucher() {
    this.modalService.openModal();
  }
}
